// JavaScript Document
//Megamenu
$(document).ready(function () {

    $(document).on("click", function (event) {
        clearMenuOpen();
    });

    $(".main_menu").on("click", ".hassub", function (event) {
        event.stopPropagation();
        if ($(event.currentTarget).hasClass("open") == false) {
            clearMenuOpen();
            $(event.currentTarget).addClass("open");
        }
        else {
            clearMenuOpen();
        }
    });

    function clearMenuOpen() {
        $(".hassub.open").removeClass("open");
    }

    //Set active menu item
    if (window.location.pathname.indexOf('/account/') != -1) {
        $("#youraccount-menu").addClass("active");
    } else if (window.location.pathname.indexOf('/community/') != -1) {
        $("#community-menu").addClass("active");
    } else if (window.location.pathname.indexOf('/insider/') != -1) {
        $("#community-menu").addClass("active");
    } else if (window.location.pathname.indexOf('/customer-forum/') != -1) {
        $("#community-menu").addClass("active");
    } else if (window.location.pathname.indexOf('/support/') != -1) {
        $("#support-menu").addClass("active");
    } else if (window.location.pathname.indexOf('/products/') != -1) {
        $("#product-menu").addClass("active");
    } else if (window.location.pathname.indexOf('/training/') != -1) {
        $("#training-menu").addClass("active");
    } else if (window.location.pathname.indexOf('/events/') != -1) {
        $("#community-menu").addClass("active");
    }

    var pathname = window.location.pathname;
    
    if (pathname != '/') {
        $('a[href$="' + pathname + '"]').parent().addClass("actpath");
    }


    $('.search-toggle').click(function () {
        $(this).toggleClass('active');
        $('.search-form').fadeToggle('fast');
    });

    //MOBILE MEGA MENU
    $('#menu-mobile > ul > li.hassub > a').click(function () {

        if ($(this).parent().hasClass('active') == false) {
            $('#menu-mobile > ul > li.hassub.active').children().next('.mobile-dropdown-menu').slideToggle();
            $('#menu-mobile > ul > li.hassub.active').toggleClass('active');
        }

        $(this).closest('li.hassub').toggleClass('active');
        $(this).next(".mobile-dropdown-menu").slideToggle();

        if ($('#menu-mobile > ul > li.hassub.active').length) {
            $('html,body').animate({ scrollTop: $('#menu-mobile').offset().top });
        } else {
            $('html,body').animate({ scrollTop: 0 });
        }

    });

    // Search
    // Synchronize desktop and mobile search boxes
    $("#search-box").keyup(function () {
        $("#search-box-m").val($("#search-box").val());
    });

    $("#search-box-m").keyup(function () {
        $("#search-box").val($("#search-box-m").val());
    });

    //build URL with querystring parameters
    $(function () {
        var searchWrapper = $('#search-wrapper');
        var searchInput = searchWrapper.find('input[name="search"]');
        var searchIndex = searchWrapper.find('input[name="search-index"]');
        var searchButton = searchWrapper.find('button');

        searchButton.click(function (e) {
            e.preventDefault();

            var index = searchIndex.val();
            var value = searchInput.val().trim();


            if (index && value !== '') {
                window.location = '/customers/search-results?indexCatalogue='
                    + index + '&searchQuery='
                    + value + '&wordsMode=0';
            }
        });

        searchInput.keypress(function (e) {
            var key = e.which;

            // the enter key code
            if (key == 13) {
                searchButton.click();
                return false;
            }
        });

    });

    //take parameters only from the synchronized desktop search box
    $("#search2").click(function () {
        $("#search1").click();
        return false;
    });

});
